import { jsx as _jsx } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
import Image from "@shared/components/contents/image/Image";
import React from "react";
import Trombinoscope from "./Trombinoscope";
const TrombinoscopePreview = () => {
    return (_jsx(Grid, { container: true, children: _jsx(Grid, { size: 4, children: _jsx(Trombinoscope, { image: _jsx(Image, { file: { url: "/exemple-trombinoscope.jpg" }, disableLazy: true }), imageHover: _jsx(Image, { file: { url: "/exemple-trombinoscope_2.jpg" }, disableLazy: true }), position: "Poste", name: "Nom", firstName: "Pr\u00E9nom", link: "link_linkedIn" }) }) }));
};
export default TrombinoscopePreview;
